import { g as getFormatDateTimeFormatter } from './formatDate-BIw3YDwX-BIw3YDwX.js';

function getFormatDateTimeToParts(getOptions) {
  return ({
    date,
    locale,
    ...restProps
  }) => {
    const dateTimeFormatter = getFormatDateTimeFormatter(locale, typeof getOptions === 'function' ? getOptions(restProps) : getOptions);
    if (!dateTimeFormatter) {
      return [{
        type: 'date',
        value: date.toString()
      }];
    }
    return dateTimeFormatter.formatToParts(date);
  };
}

export { getFormatDateTimeToParts as g };
//# sourceMappingURL=formatDateToParts-CfOqq_kj-CaUKi3-v.js.map
